/**
 * Created by dushyantha on 10/10/16.
 */
(function () {
    'use strict';

    /* @ngdoc object
     * @name trainingSchedule
     * @description
     *
     */
    angular
        .module('trainingSchedule', [
            'ui.router'
        ]);
}());
